/**
 * signalsMotion: the one place the Signals surface talks about motion.
 *
 * Motion here is motion/react only, and there is very little of it on purpose:
 *   1. the tab panel fades in when it mounts,
 *   2. a triaged card leaves the queue (transform + opacity) while the cards
 *      below it close the gap by layout,
 *   3. the steering runways draw in once, from the today point, the first time
 *      the Steering panel mounts.
 * No staggered entrances, no count-ups, no looping. House ease only, no
 * overshoot, and under prefers-reduced-motion nothing moves at all.
 */

/** The house ease, cubic-bezier(0.16, 1, 0.3, 1). */
export const HOUSE_EASE: [number, number, number, number] = [0.16, 1, 0.3, 1];

/** Spring-free reveal settings for motion components (no overshoot ever). */
export const HOUSE_TRANSITION = {
  duration: 0.4,
  ease: HOUSE_EASE,
};

/** The runway draw-in: one authored moment, played once. */
export const RUNWAY_TRANSITION = {
  duration: 0.6,
  ease: HOUSE_EASE,
};

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}
